/* eslint-disable import/prefer-default-export */
import { errorForConfig, OrderStatusAPIError, OrderStatusAPI4xx } from '../errors';

export const deriveCustomerOrderId = (orderId) => {
  if (!orderId) {
    return '';
  }
  return orderId.toString().slice(-4);
};

export const statusForState = ({ config, order }) => {
  let error = errorForConfig(config);
  const status = 200;

  if (!error && order.status.error) {
    const statusCode = order.status.error.statusCode;
    const expectedErrors = [401, 404].includes(statusCode) || statusCode >= 500;

    if (!expectedErrors) {
      if (Math.floor(statusCode / 100) === 4) {
        error = new OrderStatusAPI4xx(`API Error: Order Status (${statusCode})`);
      } else {
        error = new OrderStatusAPIError(`API Error: Order Status (${statusCode})`);
      }
    }
  }

  return {
    status: error ? 500 : status,
    error,
  };
};
